import React from "react";
import BackgroundCover from "../../components/backgroundCover/BackgroundCover";
import TitleWithDescription from "../../components/TitleWithDescription/TitleWithDescription";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import Title from "../../components/Title/Title";
import { useLanguage } from "../../context/LanguageContext";
import { clockworkAtomicTranslations } from "../../translations/clockworkAtomicTemplate";

function ClockworkAtomic() {
    const { language } = useLanguage();
    const t = clockworkAtomicTranslations[language];

    return (
        <div className="">
            <BackgroundCover
                backgroundHeight={300}
                imagePosition="initial"
                backgroundImage="/images/atomic_clock_background.jpg"
            >
                <div className="absolute top-1/2 left-[10%] -translate-y-1/2 z-10 hidden md:block">
                    <Title
                        firstLine={t.title.firstLine}
                        secondLine={t.title.secondLine}
                        className="text-white"
                        animate={true}
                    />
                </div>
            </BackgroundCover>

            <div className="mx-auto px-4 md:px-0 py-12 md:py-24">
                <div className="block md:hidden mb-8">
                    <Title
                        firstLine={t.title.firstLine}
                        secondLine={t.title.secondLine}
                        className=""
                        animate={true}
                    />
                </div>
                <div className="flex flex-col items-center">
                    <div className="max-w-4xl text-base text-gray-600 leading-relaxed">
                        <p>{t.introduction}</p>
                        <ul className="list-disc pl-6 mt-4 space-y-2">
                            {t.bulletPoints.map((point, index) => (
                                <li key={index}>{point}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="relative w-full overflow-hidden">
                <div className="w-full bg-gradient-to-b from-[#E1D8D3] via-[#FFFFFF] to-[#E1D8D3] py-12">
                    <div className="mx-auto px-4 md:px-0 pt-8 space-y-12 max-w-7xl">
                        <TimelineSection
                            title={{
                                firstLine: t.sections.understanding.title.firstLine,
                                secondLine: t.sections.understanding.title.secondLine,
                            }}
                            description={t.sections.understanding.description}
                            media={{
                                type: 'image',
                                src: "/images/atomic_clock_sub1.jpg",
                                alt: "Understanding Time"
                            }}
                            mediaPosition="right"
                        />

                        <TimelineSection
                            title={{
                                firstLine: t.sections.experiments.title.firstLine,
                                secondLine: t.sections.experiments.title.secondLine,
                            }}
                            description={t.sections.experiments.description}
                            media={{
                                type: 'image',
                                src: "/images/atomic_clock_sub2.jpg",
                                alt: "Time Dilation Experiment Part 1"
                            }}
                            mediaPosition="left"
                        />

                        <TimelineSection
                            title={{
                                firstLine: t.sections.measuring.title.firstLine,
                                secondLine: t.sections.measuring.title.secondLine,
                            }}
                            description={t.sections.measuring.description}
                            media={{
                                type: 'image',
                                src: "/images/atomic_clock_sub3.jpg",
                                alt: "Time Dilation Experiment Part 2"
                            }}
                            mediaPosition="right"
                        />

                        <TimelineSection
                            title={{
                                firstLine: t.sections.precision.title.firstLine,
                                secondLine: t.sections.precision.title.secondLine,
                            }}
                            description={t.sections.precision.description}
                            media={{
                                type: 'image',
                                src: "/images/atomic_clock_sub4.jpg",
                                alt: "Atomic Clock Precision"
                            }}
                            mediaPosition="left"
                            showLine={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClockworkAtomic; 